import Api from '../Api';
import { useParams } from 'react-router-dom';
import { usePools } from '../DatabaseContext';
import React, { useEffect, useState } from 'react';
import FormContainer from '../Fields/FormContainer';
import SaveAndContinue from '../Fields/SaveAndContinue';
import SelectQuestion from '../Fields/SelectQuestion';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';

let cityData = null

export default function LocationPage({ i18n }) {
    const { id } = useParams()
    const { setPoolId, pool } = usePools()
    const [countries, setCountries] = useState([])
    const [country, setCountry] = useState('')
    const [cities, setCities] = useState([])
    const [filteredCities, setFilteredCities] = useState([])
    const [city, setCity] = useState('')

    const updateFields = async () => {
        if (!pool) {
            return;
        }

        if (!cityData) {
            const { data } = await Api.getCityData()

            cityData = data;
        }

        const defaultCity = cityData.cities.find(c => c.default) || cityData.cities[0]
        const defaultCountry = defaultCity.country

        const selectedCountry = cityData.countries.find(c => c === pool.country) || defaultCountry
        const selectedCity = cityData.cities.find(c => c.name === pool.city && c.country === pool.country) || defaultCity

        setCity(selectedCity)
        setCountry(selectedCountry)

        setCities(cityData.cities)
        setCountries(cityData.countries)

        setFilteredCities(cityData.cities.filter(c => c.country === selectedCountry))
    }

    const notReady = () => {
        return !(
            id &&
            pool &&
            country !== undefined &&
            city !== undefined &&
            countries !== undefined &&
            cities !== undefined &&
            countries.length &&
            cityData
        );
    }

    const changeCountry = name => {
        const newCities = cities.filter(c => c.country === name);

        setCountry(name)
        setFilteredCities(newCities)
        setCity(newCities[0])
    }

    const changeCity = name => {
        setCity(
            filteredCities.find(c => c.name === name),
        )
    }

    useEffect(() => {
        setPoolId(id)
    }, [id])

    useEffect(() => {
        updateFields();
    }, [pool])

    if (notReady()) {
        return <BubbleLoader />
    }

    return <FormContainer breadcrumb={[
        { label: pool.name, url: `/${pool.id}/name` },
        { label: i18n.dimensions.heading, url: `/${pool.id}/dimensions` },
        { label: i18n.temperature.heading, url: `/${pool.id}/temperature` },
        { label: i18n.location.heading },
    ]} >

        <p>{ i18n.location.heading }</p>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8">
            <div className="flex-1">
                <SelectQuestion
                    value={ country }
                    onChange={ changeCountry }
                    name="country"
                    label={ i18n.location.country }
                    small={true}
                    options={ countries.map(country => ({
                        label: country,
                        value: country,
                    })) }
                />
            </div>
            <div className="flex-1">
                <SelectQuestion
                    value={ city.name }
                    onChange={ changeCity }
                    name="city"
                    label={ i18n.location.city }
                    small={ true}
                    options={ filteredCities.map(city => ({
                        label: city.name,
                        value: city.name,
                    })) }
                />
            </div>
        </div>

        <SaveAndContinue id={ pool?.id } data={{
            city: city.name,
            country,
            altitude: city.data.altitude,
            safety_margin: city.data.safety_margin,
            sun_intensity: city.data.sun_intensity,
            ground_temperature: city.data.ground_temperature,
        }} next="seasons" />

    </FormContainer>
}
